import { LinearProgress as LinearProgressComponent } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

interface ProgressProps {
  width: number;
}

export const Row = lib.styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  border: 1px dotted ${colors.lightGray06};
  border-radius: 10px;
  background-color: ${colors.white02};
  padding: 0px 10px 0 10px;
`;

export const AnnouncementName = lib.styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const Description = lib.styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Column = lib.styled.div`
  display: flex; 
  flex-direction: column;
  font-size: 12px;
  max-width: 140px;
`;

export const Info = lib.styled.div`
  display: flex; 
  gap: 5px;
`;

export const Buttons = lib.styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Button = lib.styled.button`
  position: relative;
  width: 80px;
  height: 28px;
  border-radius: 30px;
  border-width: 1px;
  border-style: double;
  border-color: ${colors.lightGray16};
  background-color: ${colors.white02};
  cursor: pointer;
`;

export const ButtonIcon = lib.styled.div`
  display: flex;
  position: relative;
`;

export const Title = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 7px;
  gap: 7px;


  span {
    z-index: 999;
  }
`;

export const LinearProgress = lib.styled(LinearProgressComponent)`
  position: absolute!important;
  width: 100%;
  height: 26px!important;
  border-radius: 30px;
  margin-top: -2px;

  &.MuiLinearProgress-colorPrimary {
    background-color: ${colors.white02};
  }

  && {
    .MuiLinearProgress-barColorPrimary {
      background-color: ${colors.lightBlue05};
      opacity: 0.15;
    }
  }
`;

export const Progress = lib.styled.div<ProgressProps>`
  position: absolute;
  height: 26px;
  background-color: ${colors.lightBlue05};
  opacity: 0.15;
  width: ${(props: ProgressProps) => (props.width ? props.width : 0)}%;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  border-top-right-radius: ${(props: ProgressProps) =>
    props.width && props.width > 95 ? '30' : '0'}px;
  border-bottom-right-radius: ${(props: ProgressProps) =>
    props.width && props.width > 95 ? '30' : '0'}px;
  margin-top: -4px;
`;
